import {
  Card,
  CardContent,
  Container,
  Divider,
  Typography
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import Page from 'src/components/Page';
import { getAuthorizedUser, getUser } from 'src/utils/Common';
import {
  getTasksRequest,
  resetDefects,
  resetLabours,
  resetMaterials
} from '../../store/actions';
import AtananIsler from './AssignedJob';

const useStyles = makeStyles(theme => ({
  root: {
    paddingTop: theme.spacing(0),
    paddingBottom: theme.spacing(3)
  },
  statistics: {
    marginTop: theme.spacing(3)
  },
  AtananIsler: {
    marginTop: theme.spacing(1)
  },
  projects: {
    marginTop: theme.spacing(6)
  },
  todos: {
    marginTop: theme.spacing(6)
  },
  content: {
    padding: 0,
    minHeight: 430
  }
}));

const Overview = props => {
  const classes = useStyles();
  const { t } = useTranslation('overview');
  const SessionUser = getUser();
  var TitleApp = "Sirius CRM";
  if (SessionUser.Role === 2) {
    TitleApp = "Sirius Partner"
  }
  const {
    getTasksRequest,
    resetDefects,
    resetLabours,
    resetMaterials,
    tasks
  } = props;

  const AtananIslerData = tasks.tasks;

  const handleRefresh = () => {
    getTasksRequest();
    resetLabours();
    resetDefects();
    resetMaterials();
  };

  const authorizedUser = getAuthorizedUser();


  return (
    <Page className={classes.root} title={TitleApp}>
      <Container maxWidth="xl">
        {authorizedUser && <AtananIsler
          className={classes.AtananIsler}
          AtananIsler={AtananIslerData}
          handleRefresh={handleRefresh}
          authorizedUser={authorizedUser}
        />}
      </Container>
    </Page>
  );
};
export default connect(state => ({ tasks: state.tasks1 }), {
  getTasksRequest,
  resetDefects,
  resetLabours,
  resetMaterials
})(Overview);
